import SVGIconWrapper from "./SVGIconWrapper"

const IconSchedule = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 252.98 231"
        iconClass={`icon--schedule ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M121 175H5a5 5 0 0 1-5-5V27a5 5 0 0 1 5-5h188a5 5 0 0 1 5 5V97.06c0 5.51-3.85 5.94-5 5.94a5 5 0 0 1-5-5v-.2-.81c0-.33 0-.68.05-1V32H10v133h111a5 5 0 0 1 0 10zM193 231a60.07 60.07 0 0 1-60-60v-1.09l10 .18V171.01a50 50 0 1 0 50-50V111a60 60 0 0 1 0 120z" />
        <path d="M159 30a5 5 0 0 1-5-5V5a5 5 0 0 1 10 0v20a5 5 0 0 1-5 5zM39 30a5 5 0 0 1-5-5V5a5 5 0 0 1 10 0v20a5 5 0 0 1-5 5zM206.73 189.92a5 5 0 0 1-3.54-1.46l-13.58-13.58a5 5 0 0 1-1.46-3.54V140a5 5 0 0 1 10 0v29.26l12.12 12.12a5 5 0 0 1-3.54 8.54zM138 175h-.09a5 5 0 0 1-4.91-5.09A60 60 0 0 1 193 111a5 5 0 0 1 0 10 50.23 50.23 0 0 0-50 49.09 5 5 0 0 1-5 4.91zM32.5 66.05H50v17.5H32.5z" />
        <path d="M32.5 66.05H50" />
        <path d="M61.5 66.05H79v17.5H61.5zM90.49 66.05h17.5v17.5h-17.5zM119.49 66.05h17.5v17.5h-17.5zM148.48 66.05h17.5v17.5h-17.5zM32.5 95.28H50v17.5H32.5zM61.5 95.28H79v17.5H61.5zM90.49 95.28h17.5v17.5h-17.5zM119.49 95.28h17.5v17.5h-17.5zM32.5 124.51H50v17.5H32.5zM61.5 124.51H79v17.5H61.5zM90.49 124.51h17.5v17.5h-17.5zM166 95.28h-17.5v17.5h3.88A70.36 70.36 0 0 1 166 105.3zM137 124.51h-17.5V142h8.68a70.52 70.52 0 0 1 8.82-14.62z" />
    </SVGIconWrapper>
)

export default IconSchedule